import React from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import usePaginationState from "../../customHooks/usePaginationHook";
import { useSearchParams } from "react-router-dom";
const CustomerComponent = loadable(() => import("../../components/Customer"));
type Props = {};

const Customer = (props: Props) => {
  const { pageSize, setPageSize, offset, setOffset } = usePaginationState();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";

  const { data: customerData, isPending: customerLoading } = useGetHook({
    queryKey: [`customer-${pageSize}-${offset}-${searchQuery}`],
    url: `${APIS.CUSTOMER}`,
    params: {
      limit: pageSize,
      offset: offset,
      ...(searchQuery && { search: searchQuery }),
    },
  });
  return (
    <CustomerComponent
      customerData={customerData}
      customerLoading={customerLoading}
      pageSize={pageSize}
      setPageSize={setPageSize}
      offset={offset}
      setOffset={setOffset}
    />
  );
};

export default Customer;
